import type { FC } from 'react'

import { useQuery } from '@apollo/client'
import { SDS_SPACE_MEDIUM } from '@s-group/design-system-tokens/web/tokens/space.es6'
import { getConfig } from '@shared/config'
import { LocalDomainOrderDocument } from '@shared/gql/document-nodes'
import { CheckoutButton } from 'components/CheckoutButton'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ComplementaryProductsDesktop } from './ComplementaryProducts'
import { OrderPriceSummary } from './OrderPriceSummary'

const { domain } = getConfig()

export const CheckoutSummary: FC<{
  ['data-test-id']?: string
}> = (props) => {
  const dataTestId = props['data-test-id']
  const order = useQuery(LocalDomainOrderDocument)

  const { t } = useTranslation()
  const { isSIdEnabled } = domain

  return (
    <StyledSummaryContainer data-test-id={dataTestId}>
      <div className="checkout-info">
        <OrderPriceSummary order={order.data?.domainOrder} />
        {isSIdEnabled && (
          <CheckoutButton data-test-id="checkout-button">{t('To checkout')}</CheckoutButton>
        )}
      </div>
      <ComplementaryProductsDesktop />
    </StyledSummaryContainer>
  )
}

const StyledSummaryContainer = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  height: '100%',
  overflow: 'hidden',
  display: 'grid',
  gridTemplateRows: 'min-content 1fr',
  '.checkout-info': {
    padding: SDS_SPACE_MEDIUM,
  },
}))
